<template>
  <div class="flex gap-4 border-t border-gray-300 py-4 max-md:flex-col md:items-center md:justify-between md:gap-8">
    <div class="flex gap-x-4 items-center max-md:justify-between">
      <p
        class="body-sm"
        v-text="formatDate(paymentRecord.purchase_date)"
      />

      <p
        class="body-md font-semibold"
        v-text="paymentRecord.product_name"
      />

      <a
        :href="`/account/receipt/${paymentRecord.order_id}`"
        class="link body-md font-semibold"
        v-text="'View Receipt'"
      />
    </div>
    <div>
      <p
        class="body-md font-semibold"
        v-text="formatMoney(paymentRecord.grand_total)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PaymentRecord } from '@js/api/types/customer/CustomerDashboard'
import { format } from 'date-fns'
import { formatMoney } from '@js/utils/formatMoney'

defineProps<{
  paymentRecord: PaymentRecord
}>()

const formatDate = (date: string): string => {
  return format(new Date(date), 'MM/dd/yyyy')
}
</script>
